const tableDataCheck = [
  {
    name: ["Twitter", true],
    quantity: 1485,
    date: "#pizzagate",
    progress: 35.4,
  },
  {
    name: ["Reddit", true],
    quantity: 858,
    date: "r/indiaspeaks",
    progress: 10,
  },
  {
    name: ["Instagram", false],
    quantity: 2458,
    date: "#ihatebecky",
    progress: 60,
  },
];

export default tableDataCheck;
